'use strict';
var app = require('angular').module('dashboard');

app.controller('dashboardBuilderCtrl', ['departments', "Department", 'Authentication','Form','reportConfig', 'Integration', '$state', '$stateParams', 'BuilderDataService', 'dialog','toast',"$translate","ReportConfig","$uibModal", "seletedTab", require('./dashboardBuilderCtrl')]);
app.directive('element', [require('./elementDirective')]);
app.directive('subElement', [require('./subElementDirective')]);
app.directive('subElement2', [require('./subElement2Directive')]);
app.directive('subElement3', [require('./subElement3Directive')]);

app.directive('selectOptions', [require('./select-element/selectOptions')]);
app.directive('groupOptions', [require('./group-element/groupOptions')]);
app.directive('options', [require('./optionsDirective')]);
app.directive('options2', [require('./options2Directive')]);
app.directive('options3', [require('./options3Directive')]);
app.directive('options5', [require('./options5Directive')]);

app.directive('multiSelect', [require('./multiSelectDirective')]);

app.directive('elementConfig', [require('./configDirective')]);

app.directive('formula', [require('./formulaDirective')]);
app.directive('duration', [require('./durationDirective')]);

app.directive('simpleList', [require('./simpleListDirective')]);
app.factory('FormFactory', ['Department','$translate', require('./formFactory')]);
app.factory('BuilderDataService', require('./builderDataService'));

app.directive('advancedConfig', [require('./advancedConfig/advancedConfigDirective')]);
app.directive('integrationsList', [require('./integrationsList/integrationsListDirective')]);

app.directive('dinamicConfig', [require('./dinamic-select-config/dinamicSelectConfig')]);
app.directive('dinamicGroupConfig', [require('./dinamic-group-config/dinamicGroupConfig')]);

app.directive('requiredGraph', [require('./conditions-graph/requiredGraphDirective')]);
app.directive('requiredGraph2', [require('./conditions-graph-2/requiredGraph2Directive')]);

app.directive('integration', [require('./integrationDirective')]);
app.directive('inputselectIntegration', [require('../directives/inputSelectIntegrationDirective')]);

app.directive('workflowConfig', [require('./workflowConfig/workflowConfigDirective')]);

app.directive('metadata', [require('../directives/metadataDirective')]);
app.directive('insertValue', [require('../directives/insertValueDirective')]);
app.directive('authIntegration', [require('../directives/authIntegrationDirective')]);
app.config(['$stateProvider', require('./dashboardBuilderConfig')]);

app.directive('actionWebServices', [require('./formConfig/actionWebServiceDirective')]);
app.directive('actionTask', [require('./formConfig/actionTaskDirective')]);
app.directive('actionPayload', [require('./formConfig/actionPayloadDirective')]);
